
import { defineComponent, computed } from 'vue'

export default defineComponent({
  setup (_, { emit }) {
    const desktopIcons = computed(() => [
      {
        image: 'dustbox',
        text: 'ゴミ箱'
      },
      {
        image: 'chrome',
        text: 'Google Chrome'
      },
      {
        image: 'vscode',
        text: 'Visual Studio Code'
      }
    ])
    const iconAction = ({ image }: typeof desktopIcons.value[number]) => {
      if (image === 'chrome') {
        window.open('https://www.google.com/', '_blank')
      } else if (image === 'vscode') {
        emit('open-editor')
      }
    }

    return {
      desktopIcons,
      iconAction
    }
  }
})
